import * as React from "react"

export const TextSnippetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.756 16h10.488a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.185V8.537L11.963 5H4.757a.25.25 0 0 0-.185.072.25.25 0 0 0-.072.184v10.487a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072m0 1.083q-.554 0-.947-.392a1.3 1.3 0 0 1-.392-.948V5.256q0-.554.392-.947a1.3 1.3 0 0 1 .947-.393h7.656l4.171 4.172v7.655q0 .555-.392.948a1.3 1.3 0 0 1-.947.392zm1.452-3h7.584V13H6.208zm0-2.792h7.584v-1.083H6.208zm0-2.791h5.472V7.417H6.208z"
    ></path>
  </svg>
)
